"use client";

import React, { useEffect, useState, useRef } from "react";

// import { pagesDetails , completedPropertyDetails , propertyDetails , socialMediaDetails} from "../services/api"
import "./Footer.css";
import Link from "next/link";
import { usePathname } from "next/navigation";
import Image from "next/image";
import { useSelector } from "react-redux";
// import { Link } from "react-router-dom";
// import { useLocation } from "react-router";

export default function Footer({
  adminDetail,
  ContactData,
  // propertylist,

  // pageList,
  socialList,
}) {
  const pathname = usePathname();
  const propertylist = useSelector((state) => state.inquiry.propertyList);
  const [activeIndex, setActiveIndex] = useState("");

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? "" : index);
  };

  const year = new Date().getFullYear();

  useEffect(() => {
    // loadPages()
    // loadCompletedProperties();
    // loadProperties();
    // loadSocialList();
    //    const storedData = localStorage.getItem("userData");
    // if (storedData) {
    //   const parsedData = JSON.parse(storedData);
    //   setAdminDetail(parsedData);
    // }
    setActiveIndex(null);
  }, [pathname]);

  // if (!pageList || pageList.length === 0) return null;
  const contentRefs = useRef([]);

  return (
    <>
      <div className="footer-wrapper">
        <div className="mini-container">
          <div className="inner-flex hide-tab-mobile">
            <div className="flex-row inner-flex-big section-padding-small flex-col-mob">
              <div className="inner-flex inner-flex-small footer-main">
                <div className="flex-row j-c-sb">
                  <div>
                    <div className="footer-logo footer-logo-withline">
                      {adminDetail?.logo && (
                        <Link href="/" title="">
                          <img
                            src={
                              "/images/logo-white.png" ||
                              "https://www.reecosys.com/assets/uploads/partners/logo/logo_1773732366_94.svg"
                            }
                            alt={adminDetail.name || "Logo"}
                          />
                        </Link>
                      )}
                    </div>
                  </div>
                  <div className="flex-row quick">
                    <ul className="inner-flex quick-gap footer-contact-link">
                      {/* Section title */}
                      <li className="section-footer-title">
                        <p>Contact</p>
                      </li>

                      {/* Contact links */}
                      <li className="footer-navigation-link footer-navigation-link-contact">
                        <ul className="inner-flex">
                          <li className="wfc footer-hover">
                            <a
                              href={ContactData.contact_list[0].map_url}
                              target="_blank"
                              className="footer-row"
                              rel="noopener noreferrer"
                            >
                              {/* <span className="footer-row-icon">
                                <img
                                  src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/MapPinArea.svg"
                                  alt="Map Icon"
                                />
                              </span> */}
                              <p className="capitalize footer-text">
                                {ContactData.contact_list[0].address}
                              </p>
                            </a>
                          </li>
                        </ul>
                      </li>
                      <div className="contact-flex inner-flex">
                        <li className="wfc footer-hover">
                          <a href="tel:+917575908908" className="footer-row">
                            {/* <span className="footer-row-icon">
                            <img
                              src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/PhoneCall.svg"
                              alt="Phone Icon"
                            />
                          </span> */}
                            <p className="capitalize footer-text">
                              +91 7575 908 908
                            </p>
                          </a>
                        </li>

                        <li className="wfc footer-hover">
                          <a
                            href="mailto:info@nbbuildcon.com"
                            className="footer-row"
                            rel="nofollow"
                          >
                            {/* <span className="footer-row-icon">
                            <img
                              src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/EnvelopeOpen.svg"
                              alt="Email Icon"
                            />
                          </span> */}
                            <p className="footer-text">info@nbbuildcon.com</p>
                          </a>
                        </li>
                      </div>
                      {/* Social links */}
                      {socialList != null && socialList.length > 0 && (
                        <li className="flex-row inner-flex-medium">
                          <ul className="flex-row alc">
                            {socialList.map((social, index) => (
                              <li key={index}>
                                {social.name === "facebook" && (
                                  <a
                                    href={social.slug}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src="/images/footer/uil_facebook.svg"
                                      alt="Facebook"
                                      className="social-media-icon-footer common-icon"
                                    />
                                  </a>
                                )}
                                {social.name === "instagram" && (
                                  <a
                                    href={social.slug}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src="/images/footer/ri_instagram-fill.svg"
                                      alt="Instagram"
                                      className="social-media-icon-footer common-icon"
                                    />
                                  </a>
                                )}
                                {social.name === "twitter" && (
                                  <a
                                    href={social.slug}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/social-icons/twitter.svg"
                                      alt="Twitter"
                                      className="social-media-icon-footer common-icon"
                                    />
                                  </a>
                                )}
                                {social.name === "linkedin" && (
                                  <a
                                    href={social.slug}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src="/images/footer/uil_linkedin.svg"
                                      alt="LinkedIn"
                                      className="social-media-icon-footer common-icon"
                                    />
                                  </a>
                                )}
                                {social.name === "youtube" && (
                                  <a
                                    href={social.slug}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src="/images/footer/youtube.svg"
                                      alt="YouTube"
                                      className="social-media-icon-footer common-icon"
                                    />
                                  </a>
                                )}
                              </li>
                            ))}
                          </ul>
                        </li>
                      )}
                    </ul>
                    <ul className="inner-flex marginl-auto quick-gap">
                      <li className="section-footer-title">
                        <p>Quick links</p>
                      </li>

                      <li className="footer-navigation-link">
                        <ul className="inner-flex inner-flex-smallest">
                          {/* Home */}

                          <li className="wfc footer-hover">
                            <Link
                              href="/"
                              className={pathname === "/" ? "active_page" : ""}
                            >
                              <p className="capitalize footer-text ">Home</p>
                            </Link>
                          </li>
                          <li className="wfc footer-hover">
                            <Link
                              href="/projects"
                              className={
                                pathname === "/projects" ? "active_page" : ""
                              }
                            >
                              <p className="capitalize footer-text">Projects</p>
                            </Link>
                          </li>

                          {/* About */}
                          <li className="wfc footer-hover">
                            <Link
                              href="/about-us"
                              className={
                                pathname === "/about-us" ? "active_page" : ""
                              }
                            >
                              <p className="capitalize footer-text">About Us</p>
                            </Link>
                          </li>

                          {/* Channel Partner */}
                          <li className="wfc footer-hover">
                            <Link
                              href="/channelpartner"
                              className={
                                pathname === "/channelpartner"
                                  ? "active_page"
                                  : ""
                              }
                            >
                              <p className="capitalize footer-text">
                                Channel Partner
                              </p>
                            </Link>
                          </li>

                          {/* Vendor */}
                          <li className="wfc footer-hover">
                            <Link
                              href="/vendor"
                              className={
                                pathname === "/vendor" ? "active_page" : ""
                              }
                            >
                              <p className="capitalize footer-text">Vendor</p>
                            </Link>
                          </li>

                          {/* Completed Projects */}
                          <li className="wfc footer-hover">
                            <Link
                              href="/completed-projects"
                              className={
                                pathname === "/completed-projects"
                                  ? "active_page"
                                  : ""
                              }
                            >
                              <p className="capitalize footer-text">
                                Completed Projects
                              </p>
                            </Link>
                          </li>

                          {/* Media */}
                          <li className="wfc footer-hover">
                            <Link
                              href="/media"
                              className={
                                pathname === "/media" ? "active_page" : ""
                              }
                            >
                              <p className="capitalize footer-text">Media</p>
                            </Link>
                          </li>

                          {/* Articles */}
                          <li className="wfc footer-hover">
                            <Link
                              href="/blogs"
                              className={
                                pathname === "/blogs" ? "active_page" : ""
                              }
                            >
                              <p className="capitalize footer-text">Articles</p>
                            </Link>
                          </li>

                          {/* Careers */}
                          <li className="wfc footer-hover">
                            <Link
                              href="/career"
                              className={
                                pathname === "/career" ? "active_page" : ""
                              }
                            >
                              <p className="capitalize footer-text">Careers</p>
                            </Link>
                          </li>

                          {/* Contact */}
                          <li className="wfc footer-hover">
                            <Link
                              href="/contact-us"
                              className={
                                pathname === "/contact-us" ? "active_page" : ""
                              }
                            >
                              <p className="capitalize footer-text">Contact</p>
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <ul className="inner-flex quick-gap">
                      <li className="section-footer-title">
                        <p className="">Projects</p>
                      </li>
                      <li className="footer-navigation-link">
                        <ul className="inner-flex inner-flex-smallest ">
                          {propertylist.map((data, index) => (
                            <li key={index} className="wfc footer-hover">
                              <Link
                                href={`/${data.slug}`}
                                className={
                                  pathname === `/${data.slug}` ||
                                  pathname === `/${data.slug}/`
                                    ? "active_page"
                                    : ""
                                }
                              >
                                <p className="capitalize footer-text regular-fonts">
                                  {data.project_title}
                                </p>
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="reecosys_footer_copyright section-padding-small flex-row j-c-sb alc footer-main">
              <div className="flex-row inner-flex-common">
                <div className="">
                  <p className="p0 footer-gray regular-fonts">
                    {/* &copy; {adminDetail.name} {year} */}
                    &copy; NB Buildcon {year}
                  </p>
                </div>
                {/* <div className="">
                  <p>|</p>
                </div>
                <div className="flex-row inner-flex-medium alc">
                  <div className="">
                    <ul className="flex-row inner-flex-small footer-navigation-link">
                      {pageList != null &&
                        pageList.length > 0 &&
                        pageList.map((data, index) => {
                          if (data.page_type === "legal") {
                            return (
                              <li key={index} className="wfc footer-hover">
                                <Link
                                  // /${data.slug}
                                  href={`#`}
                                  className={
                                    pathname === data.slug ? "active_page" : ""
                                  }
                                >
                                  <p className="capitalize footer-gray">
                                    {data.page_name}
                                  </p>
                                </Link>
                              </li>
                            );
                          } else {
                            return null;
                          }
                        })}
                    </ul>
                  </div>
                </div> */}
              </div>

              <div
                className="powereedby flex-row alc"
                style={{ gap: "0.3rem" }}
              >
                <div className="section-content">
                  <p className="footer-gray regular-fonts">Powered By :</p>
                </div>
                <div className="section-content wfc footer-hover reecosys-logofooter">
                  <a
                    href="https://www.reecosys.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/images/new-icons/reecosys.svg"
                      alt="Powered By : REECOSYS"
                      title="Powered By : Reecosys"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="visible-tab-mobile">
            <div className="reecosys-footer-link-sections reecosys-mainfooter-section-links">
              <div className="inner-flex  j-c-sb section-padding-small pt0 footer-mb ">
                <div className="footer-logo ">
                  <Link href="/" title={adminDetail.name}>
                    {adminDetail.logo != "" && (
                      <div>
                        <img
                          src="/images/logo-white.png"
                          alt={adminDetail.name}
                        />
                      </div>
                    )}
                    {adminDetail.logo == "" && (
                      <div className="footer_logo_text">
                        <p className="capitalize">{adminDetail.name}</p>
                      </div>
                    )}
                  </Link>
                  <br />
                </div>
                <ul>
                  <li style={{ border: "unset" }}>
                    <ul className="">
                      {/* Section title should be a <li> */}
                      <li
                        className="section-footer-title"
                        style={{ border: "unset" }}
                      >
                        <p>Contact</p>
                      </li>

                      {/* Contact items wrapper should be a nested <ul> inside a <li> */}
                      <li>
                        <ul className="inner-flex footer-navigation-link footer-navigation-link-contact">
                          {/* <li className="wfc footer-hover">
                            <a
                              href="tel:+919898800400"
                              className="footer-row"
                              rel="nofollow"
                            >
                              <span className="footer-row-icon">
                                <img
                                  src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/PhoneCall.svg"
                                  alt="Phone Icon"
                                />
                              </span>
                              <p className="capitalize footer-text">
                                +91 9898 80 0400
                              </p>
                            </a>
                          </li>

                          <li className="wfc footer-hover">
                            <a
                              href="mailto:info@nbbuildcon.com"
                              className="footer-row"
                              rel="nofollow"
                            >
                              <span className="footer-row-icon">
                                <img
                                  src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/EnvelopeOpen.svg"
                                  alt="Email Icon"
                                />
                              </span>
                              <p className="footer-text">
                                info@nbbuildcon.com
                              </p>
                            </a>
                          </li> */}

                          <li className="wfc footer-hover">
                            <a
                              href={ContactData.contact_list[0].map_url}
                              target="_blank"
                              className="footer-row"
                              rel="noopener noreferrer"
                            >
                              {/* <span className="footer-row-icon">
                                <img
                                  src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/MapPinArea.svg"
                                  alt="Map Icon"
                                />
                              </span> */}
                              <p className="capitalize footer-text neue-light-fonts">
                                {ContactData.contact_list[0].address}
                              </p>
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <div className="contact-flex inner-flex">
                    <li className="wfc footer-hover">
                      <a href="tel:+917575908908" className="footer-row">
                        {/* <span className="footer-row-icon">
                            <img
                              src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/PhoneCall.svg"
                              alt="Phone Icon"
                            />
                          </span> */}
                        <p className="capitalize footer-text neue-light-fonts">
                          +91 7575 908 908
                        </p>
                      </a>
                    </li>

                    <li className="wfc footer-hover">
                      <a
                        href="mailto:info@nbbuildcon.com"
                        className="footer-row"
                        rel="nofollow"
                      >
                        {/* <span className="footer-row-icon">
                            <img
                              src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/EnvelopeOpen.svg"
                              alt="Email Icon"
                            />
                          </span> */}
                        <p className="footer-text neue-light-fonts">
                          info@nbbuildcon.com
                        </p>
                      </a>
                    </li>
                  </div>
                </ul>
              </div>
              {socialList != null && socialList.length > 0 && (
                <div className="socail-footer-flex flex-row inner-flex-medium">
                  <ul className="flex-row alc">
                    {socialList.map((social, index) => (
                      <li key={index}>
                        {social.name == "facebook" && (
                          <a
                            href={social.slug}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="/images/footer/uil_facebook.svg"
                              alt={`Facebook ${adminDetail.name}`}
                              className="social-media-icon-footer common-icon"
                            />
                          </a>
                        )}
                        {social.name == "instagram" && (
                          <a
                            href={social.slug}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="/images/footer/ri_instagram-fill.svg"
                              alt={`Instagram ${adminDetail.name}`}
                              className="social-media-icon-footer common-icon"
                            />
                          </a>
                        )}
                        {/* {social.name == "twitter" && (
                            <a
                              href={social.slug}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/social-icons/twitter.svg"
                                alt={`X ${adminDetail.name}`}
                                className="social-media-icon-footer common-icon"
                              />
                            </a>
                          )} */}
                        {social.name == "linkedin" && (
                          <a
                            href={social.slug}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="/images/footer/uil_linkedin.svg"
                              alt={`LinkedIn ${adminDetail.name}`}
                              className="social-media-icon-footer common-icon"
                            />
                          </a>
                        )}
                        {social.name == "youtube" && (
                          <a
                            href={social.slug}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="/images/footer/youtube.svg"
                              alt={`Youtube ${adminDetail.name}`}
                              className="social-media-icon-footer common-icon"
                            />
                          </a>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              <div className="mob-link">
                <ul className="quicklinks-footer quicklinks-footer-mobile inner-flex section-content pt0 section-padding-small footer-navigation-link ">
                  <li className="project-footer-accordion">
                    <div
                      onClick={() => {
                        toggleAccordion("quick-links");
                      }}
                      className={activeIndex == "quick-links" ? "active" : ""}
                    >
                      <div className="accordionClick">
                        <p className="capitalize">Quick Links</p>

                        <div className="down_arrow_footer">
                          <img
                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/down-arrow.svg"
                            alt=""
                            className="manu-accordian-downarrow"
                          />
                          <img
                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/up-arrow.svg"
                            alt=""
                            className="manu-accordian-uparrow"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      className={`content_accordian_footer ${
                        activeIndex == "quick-links"
                          ? "content_accordianActive"
                          : ""
                      } `}
                    >
                      <ul className="inner-flex section-padding-small pb0">
                        <li style={{ paddingBottom: "0", border: "unset" }}>
                          <Link href="/">
                            <p>Home</p>
                          </Link>
                        </li>

                        <li style={{ paddingBottom: "0", border: "unset" }}>
                          <Link href="/projects">
                            <p>Projects</p>
                          </Link>
                        </li>

                        <li style={{ paddingBottom: "0", border: "unset" }}>
                          <Link
                            href="/about-us"
                            className={
                              pathname === "/about-us" ? "active_page" : ""
                            }
                          >
                            <p>About Us</p>
                          </Link>
                        </li>

                        <li style={{ paddingBottom: "0", border: "unset" }}>
                          <Link
                            href="/channelpartner"
                            className={
                              pathname === "/channelpartner"
                                ? "active_page"
                                : ""
                            }
                          >
                            <p>Channel Partner</p>
                          </Link>
                        </li>

                        <li style={{ paddingBottom: "0", border: "unset" }}>
                          <Link
                            href="/vendor"
                            className={
                              pathname === "/vendor" ? "active_page" : ""
                            }
                          >
                            <p>Vendor</p>
                          </Link>
                        </li>

                        <li style={{ paddingBottom: "0", border: "unset" }}>
                          <Link
                            href="/completed-projects"
                            className={
                              pathname === "/completed-projects"
                                ? "active_page"
                                : ""
                            }
                          >
                            <p>Completed Projects</p>
                          </Link>
                        </li>

                        <li style={{ paddingBottom: "0", border: "unset" }}>
                          <Link
                            href="/media"
                            className={
                              pathname === "/media" ? "active_page" : ""
                            }
                          >
                            <p>Media</p>
                          </Link>
                        </li>

                        <li style={{ paddingBottom: "0", border: "unset" }}>
                          <Link
                            href="/blogs"
                            className={
                              pathname === "/blogs" ? "active_page" : ""
                            }
                          >
                            <p>Articles</p>
                          </Link>
                        </li>

                        <li style={{ paddingBottom: "0", border: "unset" }}>
                          <Link
                            href="/career"
                            className={
                              pathname === "/career" ? "active_page" : ""
                            }
                          >
                            <p>Careers</p>
                          </Link>
                        </li>

                        <li style={{ paddingBottom: "0", border: "unset" }}>
                          <Link
                            href="/contact-us"
                            className={
                              pathname === "/contact-us" ? "active_page" : ""
                            }
                          >
                            <p>Contact</p>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li
                    className="project-footer-accordion"
                    style={{ border: "none" }}
                  >
                    <div
                      onClick={() => {
                        toggleAccordion("Ongoing");
                      }}
                      className={activeIndex == "Ongoing" ? "active" : ""}
                    >
                      <div className="accordionClick">
                        <p className="capitalize">Projects</p>
                        <div className="down_arrow_footer">
                          <img
                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/down-arrow.svg"
                            alt=""
                            className="manu-accordian-downarrow"
                          />
                          <img
                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/up-arrow.svg"
                            alt=""
                            className="manu-accordian-uparrow"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      ref={(el) => (contentRefs.current["Ongoing"] = el)}
                      className={`content_accordian_header ${
                        activeIndex === "Ongoing"
                          ? "content_accordianActive"
                          : ""
                      }`}
                      style={{
                        maxHeight:
                          activeIndex === "Ongoing"
                            ? `${contentRefs.current["Ongoing"]?.scrollHeight}px`
                            : "0px",
                      }}
                    >
                      <ul
                        className="inner-flex projectList_li"
                        style={{ paddingTop: "24px" }}
                      >
                        {propertylist.map((data, index) => (
                          <li key={index}>
                            <Link href={`/${data.slug}`} className="">
                              <div className="nb-mega-menu-projects-ul w100">
                                <div
                                  className="w100 relative"
                                  style={{ aspectRatio: "1080 / 844" }}
                                >
                                  <Image
                                    src={`${data.banner_data.image_web_full}&h=752&w=964&q=100`}
                                    alt="reecosys"
                                    fill
                                  />

                                  {/* {data.status && (
                                    <div
                                      className={`status-lable status-${data.status
                                        .toLowerCase()
                                        .replace(/\s+/g, "-")}`}
                                    >
                                      <p className="text-uppercase">
                                        {data.status}
                                      </p>
                                    </div>
                                  )} */}
                                </div>

                                <div
                                  className="w100 inner-flex nb-footer-ul-heading"
                                  style={{ gap: "0.25rem" }}
                                >
                                  <div className="section-paragraph ">
                                    <h4 className=" capitalize">
                                      {data.project_title}
                                    </h4>
                                  </div>

                                  <div className="inner-flex inner-flex-smallest">
                                    <div className="flex-row alc">
                                      <div className="section-content">
                                        <p className="">
                                          {data.location} <br />
                                          {data.size_price}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </li>

                  {/* <li className="project-footer-accordion">
                    <div
                      onClick={() => {
                        toggleAccordion("legal");
                      }}
                      className={activeIndex == "legal" ? "active" : ""}
                    >
                      <div className="accordionClick">
                        <p className="capitalize">Legal</p>
                        <div className="down_arrow_footer">
                          <img
                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/down-arrow.svg"
                            alt=""
                            className="manu-accordian-downarrow"
                          />
                          <img
                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/up-arrow.svg"
                            alt=""
                            className="manu-accordian-uparrow"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`content_accordian_footer ${activeIndex == "legal" ? "content_accordianActive" : ""
                        } `}
                    >
                      <ul className="inner-flex  section-padding-small pb0">
                        {pageList != null &&
                          pageList.length > 0 &&
                          pageList.map((data, index) => {
                            if (data.page_type == "legal") {
                              return (
                                <li
                                  key={index}
                                  className="pb0"
                                  style={{ border: "unset" }}
                                >
                                  <Link
                                    // /${data.slug}
                                    href={`#`}
                                    className={`${pathname == data.slug ? "active_page" : ""
                                      }`}
                                  >
                                    <p className="capitalize">
                                      {data.page_name}
                                    </p>
                                  </Link>
                                </li>
                              );
                            }
                          })}
                      </ul>
                    </div>
                  </li> */}
                </ul>
              </div>

              <ul className="quicklinks-footer-copyright">
                <li>
                  <div className="web_copyright section-content">
                    <p className="p0 footer-gray">
                      {/* &copy; {adminDetail.name} {year} */}
                      &copy; NB Buildcon {year}
                    </p>
                  </div>
                </li>
                <li className="">
                  <div
                    className="powereedby flex-row alc"
                    style={{ gap: "0.3rem" }}
                  >
                    <div className="footer-power section-content">
                      <p className="footer-gray">Powered By :</p>
                    </div>
                    <div className="footer-power section-content">
                      <a
                        href="https://www.reecosys.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/images/new-icons/reecosys.svg"
                          alt="Powered By : REECOSYS"
                          title="Powered By : Reecosys"
                        />
                      </a>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
